import {ActionTypeEnum} from "../../base/training-literals";
import {SelectionObjectTypeEnum} from "../action-literals";
import Highlight from "./highlight";

class Visibility extends Highlight {
    constructor(props = {}) {
        super(props);
        this.actionType = props.actionType || ActionTypeEnum.VISIBILITY;
    }

    startSelection() {
        if (this.selectionEnable) {
            SelectionData.resetVisibility();
            updateYellowHighlightFlag(true);
            super.startSelection();
            return;
        }

        changeSelectionAction(SelectionActionEnum.Visibility);
        if (this.selectionObjectType === SelectionObjectTypeEnum.Models) {
            SelectionData.changeResetOnOutsideClickState(true);
            onChangeApplyToSelection(false);
        } else if (this.selectionObjectType === SelectionObjectTypeEnum.Volumes) {
            SelectionData.changeResetOnOutsideClickState(true);
            onChangeApplyToSelection(true);
        } else if (this.selectionObjectType === SelectionObjectTypeEnum.Branches) {
            SelectionData.changeResetOnOutsideClickState(false);
            MeshHierarchyViewFeatureManager.resetTreeViewSelection();
            this.show2dItemsForBranchSelection();
        } else if (this.selectionObjectType === SelectionObjectTypeEnum.Groups) {
            SelectionData.changeResetOnOutsideClickState(false);
            MeshHierarchyViewFeatureManager.resetTreeViewSelection();
            this.show2dItemsForGroupSelection();
        }
    }

    stopSelection() {
        VRMessageController.addMessage({
            text: "Selection Stopped",
            priority: VrMessagePriorityEnum.LOWPRIORITYINFO
        });
        this.set2dElementsVisibility(true);
        onChangeApplyToSelection(true);
        changeSelectionAction(SelectionActionEnum.NONE);
        if (this.selectionEnable) {
            updateYellowHighlightFlag(false);
        }
        SelectionData.changeReverseHighlightState(false);
        this.change2dVisibility(true);
    }

    selectItems(items, enable) {
        if (this.selectionEnable === true) {
            super.selectItems(items, enable);
            return;
        }

        const reverse = SelectionData.reverseSelection;
        const visibilityFlag = reverse ? "1" : "0";
        const newVisibility = !enable;

        switch (this.selectionObjectType) {
            case SelectionObjectTypeEnum.Models:
                for (const item of items) {
                    if (!enable && reverse) {
                        wv.resetVisibility();
                    } else {
                        performVisibilityOperationOnModel(item.id, item.id, visibilityFlag, newVisibility);
                    }
                }
                break;
            case SelectionObjectTypeEnum.Volumes:
                for (const item of items) {
                    const modelId = getModelIdFromBranchId(item.id);
                    if (!enable && reverse) {
                        wv.resetVisibilityModel(modelId);
                    } else {
                        performVisibilityOperationOnVolume(item.id, modelId, visibilityFlag, newVisibility);
                    }
                }
                break;

            case SelectionObjectTypeEnum.Branches:
                for (const item of items) {
                    MeshHierarchyViewFeatureManager.changeTreeNodeVisibility(item.id, newVisibility, true);
                }
                break;

            case SelectionObjectTypeEnum.Groups:
                const groupIds = items.map(item => item.id);
                GroupController.onChangeVisibility(newVisibility, groupIds, false);
                break;

            default:
                console.warn("Unhandled selection object type:", this.selectionObjectType);
                break;
        }

    }

    sendDataOnSelection(data) {
        let msg = text_selectionObjects;
        this.sendDataToWeb(msg.command, data);
    }

    sendDataOnUndoSelection(data) {
        let msg = text_selectionObjects;
        this.sendDataToWeb(msg.command, data, true);
    }
}

export default Visibility;